import { Route, Routes } from "react-router-dom";

import {
  EditProperty,
  FindCustomer,
  FindProperty,
  Home,
  Login,
  TermsAndCondition,
  QueryForm,
  PrivacyPolicy,
} from "../screen";
import Protected from "./Protected";
import { UserRoles } from "../common/constants/UserRoles";
import FindCustomAd from "../screen/FindCustomAd";

const Router = () => {
  return (<>
    <Routes>
      <Route
        path="/"
        element={
          <Protected roleTypeId={UserRoles.ADMIN}>
            <Home />
          </Protected>
        }
      />
      <Route
        path="/customer"
        element={
          <Protected roleTypeId={UserRoles.ADMIN}>
            <FindCustomer />
          </Protected>
        }
      />
      <Route
        path="/property"
        element={
          <Protected roleTypeId={UserRoles.ADMIN}>
            <FindProperty />
          </Protected>
        }
      />
      <Route
        path="/property/:propertyId"
        element={
          <Protected roleTypeId={UserRoles.ADMIN}>
            <EditProperty />
          </Protected>
        }
      />
      <Route
        path="/custom-ad"
        element={
          <Protected roleTypeId={UserRoles.ADMIN}>
            <FindCustomAd />
          </Protected>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="/termsandcondition" element={<TermsAndCondition />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/query-form" element={<QueryForm />} />
    </Routes>
  </>);
};

export default Router;
